import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { DatePickerField, Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from "../../customComponents/SelectStatus";

export const initObject = {
  id: undefined,
  title: "",
  userCreatorId: 0,
  userEditorId: 0,
  createAt: "",
  updateAt: "",
  startDate: "",
  endDate: "",
  description: "",
  status: 0,
  isDeleted: false
};


export const columns = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "startDate",
    text: "از تاریخ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "endDate",
    text: "تا تاریخ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.DateColumnFormatter,
  },
  {
    dataField: "description",
    text: "توضیحات",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-6"
      },
    ]
  },
  {
    row: 2,
    list: [
      {
        name: "startDate",
        type: "date",
        component: DatePickerField,
        placeholder: "از تاریخ",
        label: "از تاریخ",
        rowIdx: 2,
        class: "col-lg-6"
      },
      {
        name: "endDate",
        type: "date",
        component: DatePickerField,
        placeholder: "تا تاریخ",
        label: "تا تاریخ",
        rowIdx: 3,
        class: "col-lg-6"
      }
    ]
  },

];

export const otherFields = [
  {
    name: "description",
    lable: "توضیحات",
    type: "textarea",
    as: "textarea",
    rowIdx: 4,
    class: "form-control"
  },

];


export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "searchText",
    lable: "MODULES.GENERAL.SEARCH",
    type: "text",
    list: [],
  },

];

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by all fields
  filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }
  newQueryParams.filter = filter;

  let whereClause = "";
  const whereClauseParameters = [];

  if (searchText != "") {
    whereClause = "title.contains(@0)";
    whereClauseParameters.push(searchText);

    if (filter.isDeleted !== undefined) {
      whereClause = whereClause + " and isDeleted=@1";
      whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    }
  }
  else if (filter.isDeleted !== undefined) {
    whereClause = whereClause + "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
  }


  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  // categoryId: Yup.number()
  //   .required("categoryId is required"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

